export default __webpack_public_path__ + "static/media/dansVan2.989ab98e.png";